"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgLocationListFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M3.98 7.99h10v2h-10zM3.98 13.99h10v2h-10zM3.98 19.99h24v2h-24zM3.98 25.99h24v2h-24zM22.82 16.74l.68.62.68-.62c.19-.18 4.82-4.49 4.82-9C29 4 27.05 2 23.5 2S18 4 18 7.73c0 4.52 4.63 8.83 4.82 9.01zm.7-7.29a2 2 0 112-1.95 2 2 0 01-2 1.95z" })));
}
exports.default = SvgLocationListFilled;
//# sourceMappingURL=LocationListFilled.js.map